import { Container, GridItem, Stack } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { AnimatedNumber, FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyOrigin } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyOrigin
}

export default function DynamicRenewableEnergy({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 15, xl: 9 }}
            gridColumnStart={{ base: 1, xl: 4 }}
            gridRowEnd={{ base: 16, xl: 11 }}
            gridColumnEnd={{ base: 3, xl: 6 }}
            alignSelf={{ base: undefined, xl: "center" }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Stack
                    flexDirection="column"
                    gap={{ base: "none", xl: "md" }}
                >
                    <Container maxWidth={200}>
                        <Text>{blok.line1}</Text>
                    </Container>

                    <Stack
                        alignItems="end"
                        gap="none"
                    >
                        <AnimatedNumber
                            target={blok.percentage}
                            final={blok.percentage}
                        />
                        <Text showcased>{blok.line3}</Text>
                    </Stack>
                    <Text>{blok.line2}</Text>
                </Stack>
            </FadeIn>
        </GridItem>
    )
}
